import { authGet, getData } from '../common'

export const getFieldsByQuery = (q) => {
    return authGet({ url: `/field?q=${JSON.stringify(q)}` }).then(getData)
}
